// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'kt-send-data-dialog',
  templateUrl: './send-data-dialog.component.html',
  styleUrls: ['./send-data-dialog.component.scss']
})
export class SendDataDialogComponent implements OnInit {
  	// Public properties
	  viewLoading = false;

  constructor(
    public dialogRef: MatDialogRef<SendDataDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		setTimeout(() => {
			this.dialogRef.close(true); // Keep only this row
		}, 2500);
	}

}
